import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <h2>عذراً، حدث خطأ ما</h2>
          <p>نحن نعمل على إصلاحه. يرجى المحاولة مرة أخرى لاحقاً.</p>
          <button onClick={() => window.location.reload()}>تحديث الصفحة</button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
